import angular, { ILogService } from 'angular'

import './editor-tabla.scss'

class EditorTablaComponentCtrl {
  editor!: string

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[EditorTablaComponentCtrl] onInit')
  }

  edita() {
    this.$log.info('editando--->')
  }
}

angular.module('candidato').component('editorTabla', {
  bindings: {
    editor: '<',
  },
  transclude: {
    tabla: '?tabla',
    cabecera: 'cabecera',
    fila: 'fila',
  },
  controller: EditorTablaComponentCtrl,
  template: require('./editor-tabla.component.html'),
})

/* class EditorItem implements ng.IDirective {
    scope = {
        editorItem: "<"
    }

    // template = "<tr><td>---- {{editorItem | json}}</td></tr>"

    controllerAs = "itemCtrl"
}

angular.module('candidato').directive("editorItem", () => new EditorItem()) */
